import { combineReducers } from 'redux';
import rawDataReducer from './rowData.reducers';

const reducer = combineReducers(Object.assign({
    rawDataReducer
}));

export default reducer;